










































import Vue from 'vue'
import { State, Action, Getter } from 'vuex-class'
import Component from 'vue-class-component'

// Vuex + typescript setup guide: https://codeburst.io/vuex-and-typescript-3427ba78cfa8

// define the module
const _CONTEXT_: string = 'context'

@Component({
  props: {
    placeholder: { type: String },
    maxMinAmounts: { type: String },
    maxlength: { type: String },
    classes: { type: String },
    inputClasses: { type: String, default: '' },
    error: { type: [Boolean, String, Function] },
    required: { type: Boolean },
    floatingLabel: { type: [Boolean, String], default: false },
    floatingLabelIsActive: { type: Boolean, default: false },
    autocomplete: { type: String, default: '' },
    autofocus: { type: Boolean, default: false },
    id: { type: String },
    label: { type: [Boolean, String] },
    tabIndex: { type: String, required: false },
    name: { type: String },
    isValid: { type: Boolean, default: true },
    validateMessage: { type: String, default: null },
    value: { type: [String, Number, Boolean] },
    asterix: { type: Boolean, default: true },
    type: { type: String, default: 'text' },
    inputmode: { type: String, default: 'search' }, // old browsers that don't support inputmode needs some value here ("none" makes the inputs non-responsive)
    pattern: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    customAttrs: { type: Object, required: false, default: () => {} }
  }
})
export default class FormInput extends Vue {
  title: string = 'FormInput'

  // initial internal state
  floatingLabelActive = false

  get isActive () {
    return this.floatingLabelActive || this.$props.value
  }
  get getWrapperClasses () {
    return `input-wrapper ${this.$slots.icon ? 'icon-input' : ''}`
  }
  get getLabelClasses () {
    return `input-label-float ${this.isActive ? 'active' : ''}`
  }
  get getInputClasses () {
    return `${this.$props.inputClasses} ${!this.$props.isValid ? 'valid' : ''}`
  }

  // methods
  handleFocus () {
    this.floatingLabelActive = true
    this.$props.focus && this.$props.focus()
  }
  handleBlur () {
    this.floatingLabelActive = false
    this.$props.blur && this.$props.blur()
  }
}
